export default {"src":"/_next/static/media/LogoMark.3743c056.svg","height":79,"width":153};